// Add custom attribute to elements containing sensible customer data,
// then Clicktale can identify and hide this data for the recordings.
const getAttributesForPIIMasking = () => {
    return {
        'data-tracking-pii': 'true',
    };
};
export default getAttributesForPIIMasking;
//# sourceMappingURL=getAttributesForPIIMasking.js.map